import { Button, Grid, TextField, Typography } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { object, string } from "yup";
import React, { useEffect } from "react";
import styles from "./SdiLogin.module.css";
import SdiService from "../../services/sdi-service";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import userState from "../../atoms/user";

const initialValues = {
  username: "",
  password: "",
};

const validationSchema = object({
  username: string().required("Required"),
  password: string().required("Required"),
});

const SdiLogin = () => {
  const navigate = useNavigate();
  const [user, setUser] = useRecoilState(userState);
  const [message, setMessage] = React.useState("");

  useEffect(() => {
    if (user) {
      navigate("/portail");
    }
  }, [user]);

  const handleSubmit = (values, actions) => {
    setMessage("👉 Tentative de connexion en cours ...");
    SdiService.login({
      username: values.username,
      password: values.password,
    })
      .then((isValid) => {
        // console.log("isValid", isValid);
        actions.setSubmitting(false);
        if (isValid) {
          setUser(values);
        } else if (!isValid) {
          setMessage("🔐 Identifiant ou mot de passe incorrect.");
        }
        return;
      })
      .catch((err) => {
        console.error(err);
        setMessage(
          "🔥 Une erreur est survenue. Si le problème persiste, contactez l'administrateur."
        );
        actions.setSubmitting(false);
      });
  };
  return (
    <div className={styles.container}>
      <img src="/images/logo.jpg" alt="SDI logo" className={styles.logo} />
      <div className={styles.card}>
        <h1 className={styles.h1}>
          Connexion à{" "}
          <span className={`${styles.h1} ${styles.blue}`}>
            SDI
            {"\u00A0"}81
          </span>
        </h1>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, actions) => handleSubmit(values, actions)}>
          {({ values, errors, isSubmitting, isValidating }) => (
            <Form className={styles.Form}>
              <div>
                <Field
                  fullWidth
                  name="username"
                  type="text"
                  label="Identifiant SDI 81"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  as={TextField}
                />
              </div>
              <div>
                <Field
                  fullWidth
                  name="password"
                  type="password"
                  label="Mot de passe"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  as={TextField}
                />
              </div>

              {message !== "" && (
                <Grid item xs={12}>
                  <Typography variant="body1" gutterBottom>
                    {message}
                  </Typography>
                </Grid>
              )}

              <Button
                type="submit"
                disabled={
                  isSubmitting || isValidating || Object.keys(errors).length
                }
                color="info">
                Continuer
              </Button>
            </Form>
          )}
        </Formik>
      </div>
      <img
        src="/images/calldispatchlogosdi81.jpg"
        alt="SDI logo"
        className={`${styles.logo} ${styles.calldispatchLogo}`}
      />
    </div>
  );
};

export default SdiLogin;
